let DataTable = require('datatables.net-bs4');

require('datatables.net-responsive-bs4');

$.extend($.fn.dataTable.defaults, {
    fnHeaderCallback: function(thead, data, start, end, display) {
        $(thead).find('th').each(function() {
            const $th = $(this);
            if ($th.hasClass('sorting_disabled')) {
                $th.removeClass('custom-sorting-icons');
                return;
            }
            if ($th.hasClass('custom-sorting-icons') || !$th.is('[class^=sorting]')) {
                return;
            }
            const content = $th.html();
            $th.html("<span>" + content + "</span><i class='custom-sorting-icons'></i>");
            $th.addClass('custom-sorting-icons');
        });
    }
})

// https://legacy.datatables.net/styling/custom_classes
$.extend(DataTable.ext.classes, {
    sFilter: "align-self-center",
    sFilterInput:  "form-control ml-0 border-0",
    sLengthSelect: "custom-select custom-select form-control form-control",
    sInfo: "align-self-center"
});



// WEBPACK FOOTER //
// ./app/assets/granite/js/datatable.js